import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BACKEND}/api`,
});

const TOKEN_KEY = "co_token";

export function setAuthToken(token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export function clearAuthToken() {
    delete api.defaults.headers.common["Authorization"];
}

export function loadStoredToken() {
    if (typeof window === "undefined") return null;
    return window.localStorage.getItem(TOKEN_KEY);
}

export function storeToken(token) {
    window.localStorage.setItem(TOKEN_KEY, token);
    setAuthToken(token);
}

export function removeStoredToken() {
    window.localStorage.removeItem(TOKEN_KEY);
    clearAuthToken();
}

// Initialize header from storage on module import
const _stored = loadStoredToken();
if (_stored) setAuthToken(_stored);

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Si è verificato un errore. Riprova.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" · ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
